module.exports = "<div class=panel-body> <h3>Not Found!</h3> <p>The page you asked for was not found. Please check your request and try again.</p> <button type=button class=\"btn btn-default btn-block\" ui-sref=storeselector>Return to home</button> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/guest/notfound/template.html
// module id = 200
// module chunks = 0